import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-application-dev',
  templateUrl: './mobile-application-dev.component.html',
  styleUrls: ['./mobile-application-dev.component.css']
})
export class MobileApplicationDevComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile-application-dev/mobile-application-dev.component.ts